function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1336",
  transform: "translate(-1133 -20)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_3",
  transform: "translate(1133 20)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 13,
  cy: 13,
  r: 13
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M13,26C5.8,26,0,20.2,0,13C0,5.8,5.8,0,13,0c7.2,0,13,5.8,13,13C26,20.2,20.2,26,13,26z M13,2C6.9,2,2,6.9,2,13 s4.9,11,11,11s11-4.9,11-11S19.1,2,13,2z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1335",
  transform: "translate(77.156 4.355)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path_873"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1073,33.1c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l2.5-2.5l-2.5-2.5c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l3.3,3.3 c0.2,0.2,0.3,0.4,0.3,0.7s-0.1,0.5-0.3,0.7l-3.3,3.3C1073.5,33,1073.2,33.1,1073,33.1z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path_874"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1064.6,33.1c-0.3,0-0.5-0.1-0.7-0.3l-3.3-3.3c-0.4-0.4-0.4-1,0-1.4l3.3-3.3c0.4-0.4,1-0.4,1.4,0c0.4,0.4,0.4,1,0,1.4 l-2.5,2.5l2.5,2.5c0.4,0.4,0.4,1,0,1.4C1065.1,33,1064.9,33.1,1064.6,33.1z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path_875"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1067.2,33.8c-0.1,0-0.2,0-0.4-0.1c-0.5-0.2-0.8-0.8-0.6-1.3l3.2-8.3c0.2-0.5,0.8-0.8,1.3-0.6c0.5,0.2,0.8,0.8,0.6,1.3 l-3.2,8.3C1068,33.6,1067.6,33.8,1067.2,33.8z"
}))));

var SvgMenuApplications = function SvgMenuApplications(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenuApplications, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu_applications.e2afa018.svg";
export { ForwardRef as ReactComponent };